import { render, staticRenderFns } from "./fix-side.vue?vue&type=template&id=76f93776&scoped=true"
import script from "./fix-side.vue?vue&type=script&lang=js"
export * from "./fix-side.vue?vue&type=script&lang=js"
import style0 from "./fix-side.vue?vue&type=style&index=0&id=76f93776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f93776",
  null
  
)

export default component.exports